module.exports = "<chassis-render [component]=\"layout\" [injector]=\"createInjector()\" [data]=\"{ containers: containers }\"></chassis-render>\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/dashboards/components/dashboard/dashboard.component.html
// module id = ./libs/chassis-core/src/app/dashboards/components/dashboard/dashboard.component.html
// module chunks = main